import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import api from '../services/api';

import BaasDashboard      from './BaasDashboard';
import GestaoCartoesBaas  from './GestaoCartoesBaas';
import ContaStarkBank    from './ContaStarkBank';
import MonitorBaas        from './MonitorBaas';
import ConciliacaoConformidade from './ConciliacaoConformidade';
import ConformidadeConfig from './ConformidadeConfig';
import AportesHub        from './AportesHub';
import BaasTransacoes    from './BaasTransacoes';

import './BaasModule.css';

// ─── Ícones inline (SVG) — não depende de libs externas ──────────────────────
const Icons = {
  Dashboard: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
    </svg>
  ),
  Cards: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="5" width="20" height="14" rx="2.5" />
      <line x1="2" y1="10" x2="22" y2="10" />
    </svg>
  ),
  Wallet: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20 12V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3" />
      <path d="M20 12h-6a2 2 0 0 0 0 4h6" />
    </svg>
  ),
  Bank: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 10 L12 4 L21 10" />
      <line x1="4" y1="10" x2="4" y2="19" />
      <line x1="9" y1="10" x2="9" y2="19" />
      <line x1="15" y1="10" x2="15" y2="19" />
      <line x1="20" y1="10" x2="20" y2="19" />
      <line x1="3" y1="20" x2="21" y2="20" />
    </svg>
  ),
  Aportes: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 3 v10" />
      <path d="M8 9 l4 4 l4 -4" />
      <path d="M4 15 v4 a1 1 0 0 0 1 1 h14 a1 1 0 0 0 1 -1 v-4" />
    </svg>
  ),
  Monitor: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  // Conciliação — duas setas confrontando (declarado × real) com um "check".
  Conciliacao: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 7 h11" />
      <path d="M12 4 l3 3 l-3 3" />
      <path d="M20 17 h-11" />
      <path d="M12 14 l-3 3 l3 3" />
    </svg>
  ),
  // Transações — extrato/tabela de compras dos cartões.
  Transacoes: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="7" y1="14" x2="12" y2="14" />
      <line x1="7" y1="17" x2="10" y2="17" />
    </svg>
  ),
  Settings: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  // Logo da Stark Bank substituindo o antigo ícone "Pomelo".
  // Raio dentro de um escudo — remete a "infraestrutura bancária instantânea".
  Stark: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 2 L20 6 V12 C20 17 16.5 20.5 12 22 C7.5 20.5 4 17 4 12 V6 Z" opacity=".25" />
      <path d="M12 2 L20 6 V12 C20 17 16.5 20.5 12 22 C7.5 20.5 4 17 4 12 V6 Z" />
      <path d="M13 7 L9 13 H12 L11 17 L15 11 H12 Z" fill="currentColor" stroke="none" />
    </svg>
  ),
  Live: () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <circle cx="12" cy="12" r="4" />
    </svg>
  ),
  Alert: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 9v4M12 17h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
    </svg>
  ),
};

const TABS = [
  { id: 'dashboard', label: 'Dashboard', Icon: Icons.Dashboard, route: '/baas/dashboard' },
  { id: 'cards',     label: 'Cartões',   Icon: Icons.Cards,     route: '/baas/cartoes'   },
  { id: 'wallet',    label: 'Conta',     Icon: Icons.Bank,      route: '/baas/carteira'  },
  { id: 'aportes',   label: 'Aportes',   Icon: Icons.Aportes,   route: '/baas/aportes'   },
  { id: 'monitor',   label: 'Monitor',   Icon: Icons.Monitor,   route: '/baas/monitor'   },
  { id: 'conciliacao', label: 'Conciliação', Icon: Icons.Conciliacao, route: '/baas/conciliacao' },
  { id: 'transacoes', label: 'Transações', Icon: Icons.Transacoes, route: '/baas/transacoes' },
];

function resolveActiveTab(pathname) {
  if (pathname.startsWith('/baas/cartoes'))  return 'cards';
  if (pathname.startsWith('/baas/carteira')) return 'wallet';
  if (pathname.startsWith('/baas/aportes'))  return 'aportes';
  if (pathname.startsWith('/baas/monitor'))  return 'monitor';
  if (pathname.startsWith('/baas/conciliacao')) return 'conciliacao';
  if (pathname.startsWith('/baas/transacoes'))  return 'transacoes';
  return 'dashboard';
}

// Tradução amigável dos status de CorporatePurchase / eventos Stark Bank
const STARK_EVENT_LABELS = {
  approved: { label: 'aprovada',  tone: 'success' },
  created:  { label: 'recebida',  tone: 'info'    },
  denied:   { label: 'negada',    tone: 'danger'  },
  reversed: { label: 'revertida', tone: 'warning' },
  voided:   { label: 'cancelada', tone: 'warning' },
};

export default function BaasModule({ user }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [liveEvents, setLiveEvents]     = useState([]);
  const [connected, setConnected]       = useState(false);
  const [showConfig, setShowConfig]     = useState(false);
  const [configInitialTab, setConfigInitialTab] = useState('status');
  const [globalAlert, setGlobalAlert]   = useState(null);

  const socketRef = useRef(null);

  const activeTab = useMemo(() => resolveActiveTab(location.pathname), [location.pathname]);

  const isAdmin = ['admin', 'admin_geral', 'financeiro'].includes(user?.perfil);
  const isAdminGeral = user?.perfil === 'admin_geral';

  // ── Socket.IO para eventos BaaS em tempo real ──────────────────────────
  useEffect(() => {
    const socket = io(process.env.REACT_APP_SOCKET_URL || window.location.origin, {
      withCredentials: true,
    });

    socketRef.current = socket;

    socket.on('connect', () => setConnected(true));
    socket.on('disconnect', () => setConnected(false));

    // Autorização síncrona aprovada (debitou saldo local na hora)
    socket.on('baas_auth_approved', (data) => {
      setLiveEvents((prev) => [
        { ...data, id: `${Date.now()}-${Math.random()}`, type: 'approved' },
        ...prev,
      ].slice(0, 50));

      flashAlert({
        type: 'success',
        msg: `Aprovado: R$ ${Number(data.valor || 0).toFixed(2)} — ${data.merchant || data.card}`,
      });
    });

    // Recarga/despesa manual em cartão 'interno'
    socket.on('baas_new_transaction', (data) => {
      setLiveEvents((prev) => [
        { ...data, id: `${Date.now()}-${Math.random()}`, type: data.tipo || 'movimento' },
        ...prev,
      ].slice(0, 50));
    });

    // Confirmação/reversão assíncrona via webhook corporate-purchase
    socket.on('baas_transaction_update', (data) => {
      const info = STARK_EVENT_LABELS[data?.status] || { label: data?.status || 'atualizada', tone: 'info' };

      setLiveEvents((prev) => [
        { ...data, id: `${Date.now()}-${Math.random()}`, type: data?.status || 'update' },
        ...prev,
      ].slice(0, 50));

      if (['denied', 'reversed', 'voided'].includes(data?.status)) {
        flashAlert({ type: 'warning', msg: `Transação ${info.label} pela Stark Bank.` });
      }
    });

    // Aporte via Pix (CorporateInvoice) confirmado/cancelado
    socket.on('baas_invoice_update', (data) => {
      if (data?.status === 'paid') {
        flashAlert({ type: 'success', msg: 'Aporte via Pix confirmado! Saldo da Conta Digital atualizado.' });
      }
    });

    // Retirada (CorporateWithdrawal) confirmada/falhou
    socket.on('baas_withdrawal_update', (data) => {
      if (data?.status === 'success') {
        flashAlert({ type: 'success', msg: 'Retirada para a conta bancária confirmada.' });
      } else if (data?.status === 'failed') {
        flashAlert({ type: 'danger', msg: 'Retirada falhou — valor revertido para a Conta Digital.' });
      }
    });

    // Reconciliação automática encontrou pares
    socket.on('baas_auto_reconcile_done', (data) => {
      flashAlert({ type: 'success', msg: `${data?.total || 0} conta(s) a receber baixada(s) automaticamente.` });
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const flashAlert = useCallback((alert) => {
    setGlobalAlert(alert);
    window.clearTimeout(window.__baasGlobalAlertTimeout);
    window.__baasGlobalAlertTimeout = window.setTimeout(() => {
      setGlobalAlert(null);
    }, 4500);
  }, []);

  const handleTabChange = (tabId) => {
    const tab = TABS.find((t) => t.id === tabId);
    if (!tab) return;
    if (location.pathname !== tab.route) {
      navigate(tab.route);
    }
  };

  const openConfig = (tab = 'status') => {
    setConfigInitialTab(tab);
    setShowConfig(true);
  };

  // ── Renderiza a tela ativa ─────────────────────────────────────────────
  const renderTab = () => {
    const commonProps = { user, isAdmin, isAdminGeral, liveEvents };

    switch (activeTab) {
      case 'dashboard':
        return <BaasDashboard />;

      case 'cards':
        // Modelo Banking: a tela de cartões é autossuficiente (checa a conexão
        // da conta e cria holders sob demanda). Não recebe mais props de holder.
        return <GestaoCartoesBaas />;

      case 'wallet':
        // "Carteira" agora é a própria Conta Digital Stark Bank (modelo Banking).
        // O WalletGestorBaas (carteira interna do Issuing) foi aposentado.
                return <ContaStarkBank user={user} />;

      case 'aportes':
        return <AportesHub />;

      case 'monitor':
        return <MonitorBaas connected={connected} />;

      case 'conciliacao':
        // Sub-rota: /baas/conciliacao/config abre a configuração da escada
        // de cobrança, sem sair da aba "Conciliação" (o resolveActiveTab já
        // trata qualquer path que comece com /baas/conciliacao como ativo).
        if (location.pathname.startsWith('/baas/conciliacao/config')) {
          return <ConformidadeConfig onVoltar={() => navigate('/baas/conciliacao')} />;
        }
        return (
          <ConciliacaoConformidade
            onAbrirConfig={() => navigate('/baas/conciliacao/config')}
          />
        );

      case 'transacoes':
        return <BaasTransacoes />;

      default:
        return <BaasDashboard />;
    }
  };

  return (
    <div className="baas-module">
      {/* ── TOPBAR ─────────────────────────────────────────────────── */}
      <header className="baas-topbar">
        <div className="baas-brand">
          <div className="baas-brand-logo">
            <Icons.Stark />
          </div>

          <div className="baas-brand-text">
            <span className="baas-brand-title">BaaS Hub</span>
            <span className="baas-brand-sub">Powered by Stark Bank</span>
          </div>
        </div>

        <nav className="baas-tabs">
          {TABS.map(({ id, label, Icon }) => (
            <button
              key={id}
              type="button"
              className={`baas-tab${activeTab === id ? ' baas-tab--active' : ''}`}
              onClick={() => handleTabChange(id)}
            >
              <span className="baas-tab-icon"><Icon /></span>
              <span className="baas-tab-label">{label}</span>

              {id === 'monitor' && liveEvents.length > 0 && (
                <span className="baas-badge">
                  {liveEvents.length > 9 ? '9+' : liveEvents.length}
                </span>
              )}
            </button>
          ))}
        </nav>

        <div className="baas-topbar-right">
          {/* Status live */}
          <div className={`baas-live-pill ${connected ? 'live-on' : 'live-off'}`}>
            <Icons.Live />
            <span>{connected ? 'LIVE' : 'OFF'}</span>
          </div>

          {/* Botão config (admin only) */}
          {isAdmin && (
            <button
              type="button"
              className="baas-btn-icon"
              onClick={() => openConfig('status')}
              title="Configurações Stark Bank"
            >
              <Icons.Settings />
            </button>
          )}
        </div>
      </header>

      {/* ── GLOBAL ALERT TOAST ─────────────────────────────────────── */}
      {globalAlert && (
        <div className={`baas-global-alert baas-alert-${globalAlert.type}`}>
          {globalAlert.msg}
        </div>
      )}

      {/* ── CONTEÚDO DA ABA ────────────────────────────────────────── */}
      <main className="baas-main">
        {renderTab()}
      </main>

      {/* ── MODAL DE CONFIGURAÇÕES ─────────────────────────────────── */}
      {showConfig && (
        <BaasConfigModal
          onClose={() => setShowConfig(false)}
          initialTab={configInitialTab}
          isAdminGeral={isAdminGeral}
        />
      )}
    </div>
  );
}

// ============================================================================
// Sub-componente: modal de configurações Stark Bank
// ============================================================================
function BaasConfigModal({ onClose, initialTab, isAdminGeral }) {
  const [tab, setTab] = useState(initialTab || 'status');
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const [migrating, setMigrating] = useState(false);
  const [migrateResult, setMigrateResult] = useState(null);

  const loadConfig = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/api/baas/config');
      setConfig(data);
    } catch {
      setConfig(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadConfig();
  }, [loadConfig]);

  const handleMigrate = async () => {
    try {
      setMigrating(true);
      const { data } = await api.post('/api/baas/migrate');
      setMigrateResult(data.migrations || []);
    } catch (e) {
      setMigrateResult([
        {
          ok: false,
          sql: 'Falha ao executar migração',
          detail: e.response?.data?.error || e.message,
        },
      ]);
    } finally {
      setMigrating(false);
    }
  };

  const copyToClipboard = (text) => {
    if (navigator.clipboard) navigator.clipboard.writeText(text).catch(() => {});
  };

  return (
    <div className="baas-modal-overlay" onClick={onClose}>
      <div className="baas-modal baas-modal--config" onClick={(e) => e.stopPropagation()}>
        <div className="baas-modal-header">
          <h3>Configurações — Stark Bank</h3>
          <button className="baas-modal-close" onClick={onClose} type="button">✕</button>
        </div>

        <div className="config-tabs">
          {['status', 'migrate'].map((t) => (
            <button
              key={t}
              type="button"
              className={`config-tab-btn ${tab === t ? 'active' : ''}`}
              onClick={() => setTab(t)}
            >
              {{ status: 'Status', migrate: 'Migração' }[t]}
            </button>
          ))}
        </div>

        <div className="config-body">
          {/* ───────────────── STATUS ───────────────── */}
          {tab === 'status' && (
            loading ? (
              <div className="config-loading">Carregando...</div>
            ) : config ? (
              <div className="config-status-grid">
                <StatusRow label="Stark Bank Configurada" value={config.stark_configured} bool />
                <StatusRow label="Ambiente" value={(config.environment || '').toUpperCase()} />
                <StatusRow label="Project ID" value={config.project_id_hint || '—'} mono />

                {!config.stark_configured && (
                  <div className="config-warn-box">
                    A SDK da Stark Bank não está inicializada neste ambiente. Verifique se
                    <code> STARKBANK_PROJECT_ID </code> e <code> STARKBANK_PRIVATE_KEY </code>
                    estão definidos nas variáveis de ambiente do servidor.
                  </div>
                )}

                <div className="config-webhook-box">
                  <label>URL de Autorização Síncrona (cadastre no painel Stark Bank → Issuing):</label>
                  <div className="config-code-row">
                    <code>{config.authorization_url}</code>
                    <button type="button" onClick={() => copyToClipboard(config.authorization_url)}>Copiar</button>
                  </div>
                </div>

                <div className="config-webhook-box">
                  <label>URL de Webhooks (cadastre no painel Stark Bank → Webhooks):</label>
                  <div className="config-code-row">
                    <code>{config.webhook_url}</code>
                    <button type="button" onClick={() => copyToClipboard(config.webhook_url)}>Copiar</button>
                  </div>
                  <small>
                    Assine os eventos: <strong>corporate-card</strong>, <strong>corporate-purchase</strong>,{' '}
                    <strong>corporate-holder</strong>, <strong>corporate-invoice</strong>, <strong>corporate-withdrawal</strong>.
                  </small>
                </div>
              </div>
            ) : (
              <p className="config-noaccess">Não foi possível carregar o status da integração.</p>
            )
          )}

          {/* ───────────────── MIGRAÇÃO ───────────────── */}
          {tab === 'migrate' && isAdminGeral ? (
            <div className="config-migrate">
              <p>Executa os comandos de criação/alteração de tabelas necessários para a integração Stark Bank.</p>

              <button
                type="button"
                className="config-migrate-btn"
                onClick={handleMigrate}
                disabled={migrating}
              >
                {migrating ? 'Migrando...' : 'Executar Migração'}
              </button>

              {migrateResult && (
                <div className="migrate-results">
                  {migrateResult.map((r, i) => (
                    <div key={i} className={`migrate-row ${r.ok ? 'ok' : 'fail'}`}>
                      {r.ok ? '✓' : '✕'} {r.sql}
                      {r.detail && <small>{r.detail}</small>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : tab === 'migrate' ? (
            <p className="config-noaccess">Sem permissão para esta aba.</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}

function StatusRow({ label, value, bool, mono }) {
  return (
    <div className="status-row">
      <span className="status-label">{label}</span>
      {bool ? (
        <span className={`status-pill ${value ? 'pill-ok' : 'pill-no'}`}>
          {value ? 'Sim' : 'Não'}
        </span>
      ) : (
        <span className={`status-value ${mono ? 'mono' : ''}`}>{value ?? '—'}</span>
      )}
    </div>
  );
}